import { useState, useEffect, RefObject } from "react";

export const useDropdownPosition = (
  dropdownRef: RefObject<HTMLDivElement>,
  isOpen: boolean,
  optionsLength: number
) => {
  const [openUpwards, setOpenUpwards] = useState(false);

  useEffect(() => {
    if (isOpen && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceNeeded = optionsLength * 38 + 40; // Approximate height needed
      setOpenUpwards(spaceBelow < spaceNeeded);
    }
  }, [isOpen, optionsLength, dropdownRef]);

  return openUpwards;
};
